/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_Scope_Plan_ChangedInputs */

const en_us2_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This exercise has already changed in your plan, so the swap is for today only.`)
};

const pt_br2_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este exercício já mudou no seu plano, então a troca vale só hoje.`)
};

const es_419_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ejercicio ya cambió en tu plan, así que el cambio vale solo por hoy.`)
};

const pt_pt2_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este exercício já mudou no teu plano, por isso a troca vale só para hoje.`)
};

const fr_fr2_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet exercice a déjà changé dans ton programme, le remplacement vaut donc pour aujourd'hui seulement.`)
};

const de_de2_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung wurde in deinem Plan schon geändert, daher gilt der Tausch nur für heute.`)
};

const it_it2_workout_swap_scope_plan_changed = /** @type {(inputs: Workout_Swap_Scope_Plan_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo esercizio è già cambiato nella tua scheda, quindi il cambio vale solo per oggi.`)
};

/**
* | output |
* | --- |
* | "This exercise has already changed in your plan, so the swap is for today only." |
*
* @param {Workout_Swap_Scope_Plan_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_plan_changed = /** @type {((inputs?: Workout_Swap_Scope_Plan_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_Plan_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_plan_changed(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_plan_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_plan_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_plan_changed(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_plan_changed(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_plan_changed(inputs)
	return en_us2_workout_swap_scope_plan_changed(inputs)
});
export { workout_swap_scope_plan_changed as "workout-swap.scope_plan_changed" }